import angular from 'angular';

export default angular.module('Serveture-Filters', []);
